<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.company.dream.titledetail') }}</h1>
    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[0]"></p>
        </div>
      </div>
      
      
      
      <!-- 第二段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[1]"></p>
        </div>
      </div>
      
      <!-- 可以根据需要添加更多的文字/图片部分 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[2]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[3]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[4]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[5]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[6]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.company.dream.content').split('---')[7]"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { useI18n } from 'vue-i18n';
import i18n from '../../../i18n';

const { t } = i18n.global;
</script>

<style scoped lang="scss">
/* 页面特定样式可以放在这里 */
.page-container{
overflow: auto; 
}
</style> 